/**
 * Paginacao local das tabelas de Avisos e Campanhas e Liberacoes.
 *
 * Nenhuma dessas listas e paginada pela API: a resposta vem inteira, e a tela
 * filtra, ordena e so entao corta a pagina. Aqui fica so a conta, sem Vue, para
 * o teste rodar em `node --test`.
 */
export const PAGE_SIZES = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

const STORAGE_PREFIX = 'pageSize:';

/** localStorage pode lancar so de ser lido (aba anonima, storage bloqueado). */
export const browserStorage = () => {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
};

export const pageCount = (total, pageSize) => Math.max(1, Math.ceil((total || 0) / pageSize));

export const clampPage = (page, total, pageSize) =>
  Math.min(Math.max(1, page || 1), pageCount(total, pageSize));

export const pageSlice = (rows, page, pageSize) => {
  const list = rows || [];
  const start = (clampPage(page, list.length, pageSize) - 1) * pageSize;
  return list.slice(start, start + pageSize);
};

const number = (value) => value.toLocaleString('pt-BR');

/** "1–10 de 243"; sem linhas, "0 de 0". */
export const rangeLabel = (page, pageSize, total) => {
  if (!total) return '0 de 0';
  const current = clampPage(page, total, pageSize);
  const start = (current - 1) * pageSize + 1;
  const end = Math.min(current * pageSize, total);
  return number(start) + '–' + number(end) + ' de ' + number(total);
};

/**
 * Botoes numerados: primeira, ultima, a atual e as vizinhas; o resto vira
 * "…". Lacuna de uma pagina so mostra o numero — "…" no lugar de um unico
 * botao esconderia a pagina sem economizar espaco.
 */
export const pageItems = (page, count) => {
  if (count <= 7) return Array.from({ length: count }, (_, i) => i + 1);

  const keep = [1, page - 1, page, page + 1, count]
    .filter((value, index, all) => value >= 1 && value <= count && all.indexOf(value) === index)
    .sort((a, b) => a - b);

  const items = [];
  keep.forEach((value, index) => {
    const previous = keep[index - 1];
    if (previous !== undefined && value - previous === 2) items.push(previous + 1);
    else if (previous !== undefined && value - previous > 2) items.push('…');
    items.push(value);
  });
  return items;
};

/**
 * Tamanho escolhido por tabela, lembrado no navegador. Aba anonima ou storage
 * bloqueado lancam no acesso: a tabela cai no padrao em vez de quebrar.
 */
export const readPageSize = (storage, key, fallback) => {
  if (!storage || !key) return fallback;
  try {
    const value = Number(storage.getItem(STORAGE_PREFIX + key));
    return PAGE_SIZES.indexOf(value) !== -1 ? value : fallback;
  } catch (e) {
    return fallback;
  }
};

export const writePageSize = (storage, key, value) => {
  if (!storage || !key) return;
  try {
    storage.setItem(STORAGE_PREFIX + key, String(value));
  } catch (e) {
    /* sem storage o tamanho so nao sobrevive a proxima visita. */
  }
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/default/pagination.js